// extracted by mini-css-extract-plugin
module.exports = {"items":"styles_items__93W7-","footer":"styles_footer__2Z5d8"};